import React, { useContext, useState, useEffect } from "react";
import { Snackbar, IconButton, SnackbarContent } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import axios from "axios";
import isEmail from "validator/lib/isEmail";
import { makeStyles } from "@material-ui/core/styles";
import emailjs from "emailjs-com";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger"; // ScrollTrigger plugin
import { LanguageContext } from "../../contexts/LanguageContext"; // Import the context

import {
    FaTwitter,
    FaLinkedinIn,
    FaGithub,
    FaYoutube,
    FaBloggerB,
    FaRedditAlien,
    FaStackOverflow,
    FaCodepen,
    FaInstagram,
    FaGitlab,
    FaMediumM,
} from "react-icons/fa";
import { AiOutlineSend, AiOutlineCheckCircle } from "react-icons/ai";
import { FiPhone, FiAtSign } from "react-icons/fi";
import { HiOutlineLocationMarker } from "react-icons/hi";

import { ThemeContext } from "../../contexts/ThemeContext";

import { socialsData } from "../../data/socialsData";
import { contactsData } from "../../data/contactsData";
import "./Contacts2.css";

function Contacts2() {
    const [open, setOpen] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [success, setSuccess] = useState(false);
    const [errMsg, setErrMsg] = useState("");
    const { theme } = useContext(ThemeContext);
    const { language } = useContext(LanguageContext); // Use LanguageContext

    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpen(false);
    };

    const useStyles = makeStyles((t) => ({
        input: {
            border: `2px solid ${theme.primary80}`,
            borderRadius: "5px",
            backgroundColor: `${theme.secondary}`,
            color: `${theme.tertiary}`,
            fontFamily: "var(--primaryFont)",
            fontWeight: 500,
            transition: "border 0.2s ease-in-out",
            "&:focus": {
                border: `2px solid ${theme.primary600}`,
            },
        },
        message: {
            border: `2px solid ${theme.primary80}`,
            borderRadius: "5px",
            backgroundColor: `${theme.secondary}`,
            color: `${theme.tertiary}`,
            fontFamily: "var(--primaryFont)",
            fontWeight: 500,
            transition: "border 0.2s ease-in-out",
            // "&:focus": {
            //     border: `4px solid ${theme.primary600}`,
            // },
        },
        label: {
            backgroundColor: `${theme.secondary}`,
            color: `${theme.primary}`,
            fontFamily: "var(--primaryFont)",
            fontWeight: 600,
            fontSize: "0.9rem",
            padding: "0 5px",
            transform: "translate(25px,50%)",
            display: "inline-flex",
            borderRadius: "5px",
        },
        socialIcon: {
            width: "45px",
            height: "45px",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "21px",
            backgroundColor: theme.primary,
            color: theme.secondary,
            transition: "250ms ease-in-out",
            "&:hover": {
                transform: "scale(1.1)",
                color: theme.secondary,
                backgroundColor: theme.tertiary,
            },
        },
        detailsIcon: {
            backgroundColor: theme.primary,
            color: theme.secondary,
            borderRadius: "50%",
            width: "45px",
            height: "45px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "23px",
            transition: "250ms ease-in-out",
            flexShrink: 0,
            "&:hover": {
                transform: "scale(1.1)",
                color: theme.secondary,
                backgroundColor: theme.tertiary,
            },
        },
        submitBtn: {
            backgroundColor: theme.primary,
            color: theme.secondary,
            transition: "250ms ease-in-out",
            "&:hover": {
                transform: "scale(1.08)",
                color: theme.secondary,
                backgroundColor: theme.tertiary,
            },
        },
    }));

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!name || !isEmail(email) || !message) {
            setErrMsg("Please fill all fields correctly.");
            return;
        }

        emailjs
            .send(
                "service_bb7j0lj",
                "template_sj1eqvs",
                {
                    from_name: name,
                    from_email: email,
                    message: message,
                },
                "2lfwPTWiFqaJV_JKb"
            )
            .then(() => {
                setSuccess(true);
                setName("");
                setEmail("");
                setMessage("");
            })
            .catch((error) => {
                setErrMsg("Failed to send message.");
            });
    };

    // GSAP and ScrollTrigger animations
    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        gsap.fromTo(
            ".contacts-section h1",
            { opacity: 0, y: -50 },
            {
                opacity: 1,
                y: 0,
                duration: 1,
                scrollTrigger: {
                    trigger: ".contacts-section h1",
                    start: "top 80%",
                    end: "top 50%",
                },
            }
        );
        gsap.fromTo(
            ".contacts-image img",
            { opacity: 0, x: 0 ,scale:0.7},
            {
                opacity: 1,
                x: 0,
                duration: 1,
                scale: 1,
                scrollTrigger: {
                    trigger: ".contacts-image img",
                    start: "top 80%",
                    end: "top 50%",
                },
            }
        );
        gsap.fromTo(
            ".contacts-form input, .contacts-form textarea",
            { opacity: 0, x: 0,scale:0.7 },
            {
                opacity: 1,
                scale: 1,
                x: 0,
                duration: 1,
                stagger: 0.2,
                scrollTrigger: {
                    trigger: ".contacts-form",
                    start: "top 80%",
                    end: "top 50%",
                },
            }
        );

        gsap.fromTo(
            ".submit-btn",
            { opacity: 0, scale: 0.8 },
            {
                opacity: 1,
                scale: 1,
                duration: 1,
                delay: 0.5,
                scrollTrigger: {
                    trigger: ".submit-btn",
                    start: "top 80%",
                    end: "top 50%",
                },
            }
        );
    }, []);

    const classes = useStyles();
    return (
        <div className="contacts-section" id="contactMe">
            <h1>
                {language === "en" ? "Contact Me" : "Contactez Moi"}
            </h1>
            <div className="contacts-container">
                <div className="contacts-form">
                    <form onSubmit={handleSubmit}>
                        <div className="input-container">
                            <input
                                placeholder={language === "en" ? "Full Name" : "Nom Complet"}
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                type="text"
                                name="Name"
                                className={`form-input ${classes.input}`}
                            />
                        </div>
                        <div className="input-container">
                            <input
                                placeholder={language === "en" ? "Mail" : "Email"}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                type="email"
                                name="Email"
                                className={`form-input ${classes.input}`}
                            />
                        </div>
                        <div className="input-container">
                            <textarea
                                placeholder={language === "en" ? "Type your message..." : "Écrivez votre message..."}
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                type="text"
                                name="Message"
                                className={`form-message ${classes.message}`}
                            />
                        </div>

                        <div className="submit-btn">
                            <button type="submit" className={classes.submitBtn}>
                                <p>{!success ? (language === "en" ? "Send" : "Envoyer") : (language === "en" ? "Sent" : "Envoyé")}</p>
                                <div className="submit-icon">
                                    <AiOutlineSend
                                        className="send-icon"
                                        style={{
                                            animation: !success
                                                ? "initial"
                                                : "fly 0.8s linear both",
                                            position: success ? "absolute" : "initial",
                                        }}
                                    />
                                    <AiOutlineCheckCircle
                                        className="success-icon"
                                        style={{
                                            display: !success ? "none" : "inline-flex",
                                            opacity: !success ? "0" : "1",
                                        }}
                                    />
                                </div>
                            </button>
                        </div>
                    </form>
                </div>
                <div className="contacts-image">
                    <img
                        src={theme.contactsimg}
                        alt="contacts"
                        className="contacts--img"
                    />
                </div>
            </div>
            <div className="mail">
                <a className="personal-details">
                    <div className={classes.detailsIcon}>
                        <FiAtSign />
                    </div>
                    <p style={{ color: theme.tertiary }}>{contactsData.email}</p>
                </a>
            </div>
            <div className="socialmedia-icons">
                {socialsData.github && (
                    <a
                        href={socialsData.github}
                        target="_blank"
                        rel="noreferrer"
                        className={classes.socialIcon}
                    >
                        <FaGithub aria-label="GitHub" />
                    </a>
                )}
                {socialsData.linkedIn && (
                    <a
                        href={socialsData.linkedIn}
                        target="_blank"
                        rel="noreferrer"
                        className={classes.socialIcon}
                    >
                        <FaLinkedinIn aria-label="LinkedIn" />
                    </a>
                )}
            </div>
        </div>
    );
}

export default Contacts2;
